<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <span>Заказ оформлен</span>
        </h1>
      </div>



      <div class="page_content order">

        <div class="order_blocks">
          <products-block order-id="241"></products-block>
        </div>

        <div class="total">
          <div class="total-panel">
            <div class="top">
              <span class="title">Способ доставки</span>
              <span class="value">Экспресс-доставка до двери</span>
            </div>
            <div class="sep"></div>
            <div class="address">
              <span class="desc">Адрес доставки:</span>
              <span class="val">
                г. Екатеринбург,<br>
                ул. Черняховского, 86/10</span>
            </div>
            <div class="price_time">
              <div class="item price">
                <span class="desc">Стоимость доставки:</span>
                <span class="val">2 490₽</span>
              </div>
              <div class="item time">
                <span class="desc">Срок доставки:</span>
                <span class="val">14-21 дней</span>
              </div>
            </div>
          </div>

          <div class="total-panel payment">
            <div class="top">
              <span class="title">Способ оплаты</span>
              <span class="value">Банковской картой</span>
            </div>
            <div class="sep"></div>
            <div class="rows">
              <div class="row">
                <span class="desc">Всего товаров доставят:</span>
                <span class="val">12 шт</span>
              </div>
              <div class="row">
                <span class="desc">Итого к оплате:</span>
                <span class="val">360 000₽</span>
              </div>
            </div>
            <standart-button style_type="prime" text="Оплатить"></standart-button>
          </div>
        </div>

      </div>


    </template>
  </main-template>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue';
import ProductsBlock from "@/components/order/ProductsBlock";
import StandartButton from "@/components/share/StandartButton";




export default {
  name: 'OrderFinishView',
  components: {
    StandartButton,
    MainTemplate,
    ProductsBlock,
  },
  data() {
    return{

    }
  },
  mounted() {

  },
  methods : {

  }
}
</script>

<style scoped>

.back {
  height: 40px;
  width: 40px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--White);
  cursor: pointer;
  border: 1px solid var(--Border, #EDEDED);
}

.page_top .title {
  gap: 12px;
  align-items: center;
}

.page_content.order {
  display: flex;
  gap: 20px;
}

.order_blocks {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.total {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.total-panel {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 20px;
}

.total-panel .top {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.total-panel .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
}

.total-panel .value {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
}

.total-panel .sep {
  height: 1px;
  background: #EDEDED;
  margin: 20px -20px;
}

.total-panel .address {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.total-panel .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.total-panel .val {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.total-panel .price_time {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.total-panel .price_time .item{
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.total-panel.payment .rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
}
.total-panel.payment .row {
  display: flex;
  justify-content: space-between;
}


/*MOBILE*/
@media (max-width: 1250px)
{
  .page_content.order {
    display: flex;
    flex-direction: column-reverse;
    gap: 20px;
  }

  .order_blocks {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .total {
    gap: 10px;
  }

  .total-panel {
    padding: 18px;
  }
}
</style>



<style>

.total-panel.payment .standart_button {
  width: 100%;
}

.hint_button svg path, .hint_button svg circle {
  stroke: var(--Black, #222);;
}

/*MOBILE*/
@media (max-width: 1250px)
{

}

</style>
